import util from '@bmp-vue/core/api/util'

const controller = 'Account'
export default Object.assign({}, util.GetCrud(controller, null))
